import moduleApi, { Module, ModuleSearchParams, ApiResponse } from '@/modules/lms/modules/apis/moduleApi';
import apiClient from '@/lib/api-client';

// Service that handles module operations, always using real API without fallbacks
const moduleService = {
  getModules: async (): Promise<Module[]> => {
    const response = await moduleApi.getModules();
    return response.data;
  },

  getModule: async (id: string): Promise<Module> => {
    const response = await moduleApi.getModule(id);
    return response.data;
  },

  // Get module with full details including sections, activities, and versions
  getModuleDetail: async (id: string): Promise<Module> => {
    const response = await apiClient.get(`/module/${id}`);
    return response.data.data;
  },

  // Get module with full details for editing
  getModuleEdit: async (id: string): Promise<Module> => {
    const response = await apiClient.get(`/module/${id}/edit`);
    return response.data.data;
  },

  searchModules: async (params: ModuleSearchParams): Promise<Module[]> => {
    const response = await moduleApi.searchModules(params);
    return response.data;
  },

  createModule: async (moduleData: Partial<Module>): Promise<Module> => {
    const response = await moduleApi.createModule(moduleData);
    return response.data;
  },

  updateModule: async (id: string, moduleData: Partial<Module>): Promise<Module> => {
    const response = await moduleApi.updateModule(id, moduleData);
    return response.data;
  },

  deleteModule: async (id: string): Promise<void> => {
    await moduleApi.deleteModule(id);
  },
  
  // Save module structure (sections and activities)
  saveModuleStructure: async (id: string, moduleData: Partial<Module>): Promise<Module> => {
    const response = await apiClient.post(`/module/${id}/structure`, moduleData);
    return response.data.data;
  }
};

export default moduleService; 